import {
  OLHostFamilyPricePerNight,
  OlRateIdInput
} from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { OLHostFamilyPricePerNightInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateOlHostFamilyPrice = async (
  data: Partial<OLHostFamilyPricePerNightInput> & OlRateIdInput
) => {
  const { id, olId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.updateOlHostFamilyPrice.url, { id, olId }))
    .patch<OLHostFamilyPricePerNight, Partial<OLHostFamilyPricePerNightInput>>(rest)
}
